import { render } from "./index.vue?vue&type=template&id=45a62e9e&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=45a62e9e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a62e9e"]])

export default __exports__